export const DEFAULT_BRAND_THEME = {
  primary: "#F7B500",
  accent: "#9a3412",
  cta: "#0f766e",
  background: "#fffaf3",
  surface: "#ffffff",
  text: "#431407",
  muted: "#9a3412",
  dark: "#17110c",
  onPrimary: "#111111",
  onCta: "#ffffff",
};

const COLOR_RE =
  /^(#([0-9a-f]{3}|[0-9a-f]{6})|rgb\([^)]+\)|rgba\([^)]+\)|hsl\([^)]+\)|hsla\([^)]+\))$/i;

function cleanColor(value, fallback) {
  const v = String(value || "").trim();
  return COLOR_RE.test(v) ? v : fallback;
}

export function normalizeBrandTheme(raw = {}, fallback = DEFAULT_BRAND_THEME) {
  const base = { ...DEFAULT_BRAND_THEME, ...fallback };

  return {
    primary: cleanColor(raw.primary, base.primary),
    accent: cleanColor(raw.accent, base.accent),
    cta: cleanColor(raw.cta, base.cta),
    background: cleanColor(raw.background, base.background),
    surface: cleanColor(raw.surface, base.surface),
    text: cleanColor(raw.text, base.text),
    muted: cleanColor(raw.muted, base.muted),
    dark: cleanColor(raw.dark, base.dark),
    onPrimary: cleanColor(raw.onPrimary, base.onPrimary),
    onCta: cleanColor(raw.onCta, base.onCta),
  };
}

export function brandThemeCssVars(theme = DEFAULT_BRAND_THEME) {
  const t = normalizeBrandTheme(theme);

  return {
    "--brand-primary": t.primary,
    "--brand-accent": t.accent,
    "--brand-cta": t.cta,
    "--brand-bg": t.background,
    "--brand-surface": t.surface,
    "--brand-text": t.text,
    "--brand-muted": t.muted,
    "--brand-dark": t.dark,
    "--brand-on-primary": t.onPrimary,
    "--brand-on-cta": t.onCta,
  };
}
